export default __webpack_public_path__ + "01568180b166f50e2989ba865ae84581.png";